import * as Yup from 'yup';

const ClinicSchema = (threshold) =>
  Yup.object().shape({
    guid: Yup.string(),
    agencyGuid: Yup.string().required(),
    legalname: Yup.string().required('Legal Name is required field'),
    email: Yup.string().email('Email is not correct'),
    phone: Yup.string().matches(/^[+][0-9]*$/, 'Phone number is not correct'),
    callerId: Yup.string().matches(
      /^[+][0-9]*$/,
      'Clinic CallerID is not correct',
    ),
    fax: Yup.string(),
    addressLine1: Yup.string(),
    addressLine2: Yup.string(),
    city: Yup.string().when('zip', {
      is: (zip) => !!zip,
      then: (schema) => schema.required().nullable(),
      otherwise: (schema) => schema.nullable(),
    }),
    state: Yup.string().when(['zip', 'city'], {
      is: (zip, city) => !!zip || !!city,
      then: Yup.string().required().nullable(),
      otherwise: Yup.string().nullable(),
    }),
    zip: Yup.string().nullable(),
    timezone: Yup.string().nullable(),
    npiNumber: Yup.string(),
    stateIdNumber: Yup.string(),
    taxIdNumber: Yup.string(),
    taxonomyNumber: Yup.string(),
    medicalIdTpiNumber: Yup.string(),
    medicareNumber: Yup.string(),
    clinicId: Yup.string(),
    threshold,
    status: Yup.string(),
    parentClinicGuid: Yup.string().nullable(),
    ots: Yup.boolean().nullable(),
    otsStartDate: Yup.date()
      .typeError(
        'OTS Start Date must be in the format MM-DD-YYYY. Please set the correct date.',
      )
      .nullable(),
    autoGeneratedClaimDrop: Yup.boolean().nullable(),
    finId: Yup.string().nullable(),
    acceptPvrLite: Yup.boolean(),
    notes: Yup.string().when('validateRunBook', {
      is: (validateRunBook) => validateRunBook,
      then: Yup.string().required('Note required'),
      otherwise: Yup.string().nullable(),
    }),
    dateNoteLogged: Yup.date().when('validateRunBook', {
      is: (validateRunBook) => validateRunBook,
      then: Yup.date()
        .typeError(
          'Date Note must be in the format MM-DD-YYYY. Please set the correct date.',
        )
        .required('Date note required'),
      otherwise: Yup.date()
        .typeError(
          'Date Note must be in the format MM-DD-YYYY. Please set the correct date.',
        )
        .nullable(),
    }),
    validateRunBook: Yup.boolean(),
  });

export default ClinicSchema;
